
const liveInfo=[
  {
    img:'/static/liveFile/liveImg/gulive3.jpg',
    liveName:'冠心病早期预警',
    hosName:'南京鼓楼医院',
    doctorName:'王昆',
    doctorTitle:'副主任医师',
    liveTime:'2020-07-14 10:00',
    liveUrl:'https://wx.vzan.com/live/tvchat-15039557?shareuid=0&v=1594795075566&fr=#/'
  },
  {
    img:'/static/liveFile/liveImg/gulive1.jpg',
    liveName:'发现劲动脉斑块怎么办',
    hosName:'南京鼓楼医院',
    doctorName:'李敬伟',
    doctorTitle:'主任医师',
    liveTime:'2020-07-06 10:00',
    liveUrl:'https://wx.vzan.com/live/tvchat-1311645629?shareuid=0&v=1594795790536&fr=#/'
  },
  {
    img:'/static/liveFile/liveImg/gulive2.jpg',
    liveName:'腰椎间盘突出检测和治疗',
    hosName:'南京鼓楼医院',
    doctorName:'陶高见',
    doctorTitle:'主任医师',
    liveTime:'2020-07-03 10:00',
    liveUrl:'https://wx.vzan.com/live/tvchat-1539294277?shareuid=0&v=1594795828835&fr=#/'
  },
  {
    img:'/static/liveFile/liveImg/gulive4.png',
    liveName:'抑郁焦虑的识别',
    hosName:'南京鼓楼医院',
    doctorName:'赵鹏',
    doctorTitle:'副主任医师',
    liveTime:'2020-05-13 17:30',
    liveUrl:'https://wx.vzan.com/live/tvchat-297415352?shareuid=0&v=1594795853051&fr=#/'
  }
]

const hosList=[
  {
    sn:'1',
    hosName:'鼓楼医院'
  }
]



export default {
  liveInfo,
  hosList
}



//////////////////
// WEBPACK FOOTER
// ./static/liveFile/liveFile.js
// module id = null
// module chunks = 